"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SmartTable = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var types = _interopRequireWildcard(require("../../constants"));

var _Sizify = _interopRequireDefault(require("../../../Sizify"));

var _helper = require("../../helper");

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultTableSettings = {
  pageIndex: 0,
  rowsPerPage: 10,
  searchTerm: '',
  selectedRows: [],
  selectedFilters: {},
  sortColumn: '',
  sortDirection: null
};

var SmartTable = /*#__PURE__*/function (_Component) {
  _inherits(SmartTable, _Component);

  var _super = _createSuper(SmartTable);

  function SmartTable() {
    var _this;

    _classCallCheck(this, SmartTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      actions: [],
      bulkActions: [],
      // provided from TableToolbar
      bulkStatusChange: false,
      // provided from TableToolbar
      columns: [],
      emptyMessage: '',
      searchTerm: '',
      idKey: '',
      isFiltered: false,
      paginate: false,
      rowData: [],
      selectEnabled: false,
      showSearchSuggestions: false,
      statusOptions: null,
      tableSettings: _objectSpread(_objectSpread({}, defaultTableSettings), _this.props.tableSettings),
      title: ''
    });

    _defineProperty(_assertThisInitialized(_this), "getFormattedRowData", function (selectedRows) {
      var resetData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var statusOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.state.statusOptions;
      var _this$props = _this.props,
          columns = _this$props.columns,
          rows = _this$props.rows,
          idKey = _this$props.idKey,
          selectEnabled = _this$props.selectEnabled;

      var visibleColumns = _this.getVisibleColumns(columns);

      var rowData = (0, _lodash.cloneDeep)(rows);
      var tableSettings = _this.state.tableSettings;

      if (!resetData) {
        var column = columns.find(function (column) {
          return column.key === tableSettings.sortColumn;
        });
        rowData = tableSettings.sortColumn // sort if sortColumn is provided
        ? (0, _helper.dataSort)(tableSettings.sortDirection, column, (0, _helper.dataFilter)(rowData, visibleColumns, idKey, tableSettings.searchTerm)) : (0, _helper.dataFilter)(rowData, visibleColumns, idKey, tableSettings.searchTerm);
        rowData.forEach(function (row) {
          if (row.filtered) {
            // If anything in row becomes a filter status of false, the entire row should be filtered out of displayed data (filter: false)
            var isFiltered = !Object.entries(tableSettings.selectedFilters).some(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                  key = _ref2[0],
                  filters = _ref2[1];

              return !filters.includes(row[key]) && filters.length > 0;
            });
            row.filtered = isFiltered;
            row.selected = isFiltered ? row.selected : false; // if row is now filtered out (false), unselect row
          }
        });

        if (selectEnabled) {
          rowData.forEach(function (row) {
            row.selected = row.selected ? row.selected : selectedRows.some(function (selected) {
              return selected[idKey] === row[idKey];
            });
          });
        }

        if (statusOptions) {
          rowData.forEach(function (row) {
            row.statusOption = row.statusOption ? row.statusOption : statusOptions[0].value;
          });
        }
      } else {
        // resets to original data and removes all filtering
        rowData.forEach(function (row) {
          return row.filtered = true;
        });
      }

      _this.props.onChange(rowData, tableSettings);

      return rowData;
    });

    _defineProperty(_assertThisInitialized(_this), "getFormattedColumns", function (columns) {
      return columns.map(function (column) {
        return _objectSpread(_objectSpread({}, column), {}, {
          show: column.show !== undefined ? column.show : true
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getFormattedStatusOptions", function () {
      // formats statusOptions to move a potential disabled property into a props object for the Dropdown to use
      var statusOptionsColumn = _this.props.columns.find(function (column) {
        return column.statusOptions !== undefined;
      }) || {};
      var statusOptions = statusOptionsColumn.statusOptions || null;
      statusOptions && statusOptions.forEach(function (option) {
        return option.props = {
          disabled: option.disabled === undefined ? false : option.disabled
        };
      });
      return statusOptions;
    });

    _defineProperty(_assertThisInitialized(_this), "selectAllRowsHandle", function (allSelected) {
      var tableSettings = _this.state.tableSettings;
      var updatedRowData = (0, _lodash.cloneDeep)(_this.state.rowData);
      var updatedSelectedRows = [];

      if (allSelected && tableSettings.selectedRows.length === 0) {
        // nothing is currently selected
        updatedRowData.forEach(function (row) {
          return row.selected = row.filtered;
        }); // if data is filtered, will only select all that are currently showing

        updatedSelectedRows = updatedRowData.filter(function (row) {
          return row.selected;
        });
      } else {
        // clicking select all when some are already selected, unselects all rows
        updatedRowData.forEach(function (row) {
          return row.selected = false;
        });
      }

      var updatedTableSettings = _objectSpread(_objectSpread({}, tableSettings), {}, {
        selectedRows: updatedSelectedRows
      });

      _this.setState({
        rowData: updatedRowData,
        tableSettings: updatedTableSettings
      });

      _this.props.onChange(updatedRowData, updatedTableSettings);
    });

    _defineProperty(_assertThisInitialized(_this), "getVisibleColumns", function (columns) {
      var windowWidth = _this.props.size.windowWidth;
      var visibleColumns = [];
      columns.forEach(function (column) {
        if (column.show !== undefined && !column.show) return;else if (windowWidth < 600 && (column.hideOn && column.hideOn.indexOf(types.PHONE) === -1 || !column.hideOn)) {
          visibleColumns.push(column);
        } else if (windowWidth >= 600 && windowWidth < 1200 && (column.hideOn && column.hideOn.indexOf(types.TABLET) === -1 || !column.hideOn)) {
          visibleColumns.push(column);
        } else if (windowWidth >= 1200) {
          visibleColumns.push(column);
        }
      });
      return visibleColumns;
    });

    return _this;
  }

  _createClass(SmartTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          actions = _this$props2.actions,
          columns = _this$props2.columns,
          emptyMessage = _this$props2.emptyMessage,
          idKey = _this$props2.idKey,
          selectEnabled = _this$props2.selectEnabled,
          title = _this$props2.title;
      var tableSettings = this.state.tableSettings;
      var selectedRows = tableSettings.selectedRows || defaultTableSettings.selectedRows;
      var statusOptions = this.getFormattedStatusOptions();
      var rowData = this.getFormattedRowData(selectedRows, false, statusOptions);
      this.setState({
        actions: actions,
        columns: this.getFormattedColumns(columns),
        emptyMessage: emptyMessage,
        idKey: idKey,
        isFiltered: false,
        rowData: rowData,
        // data that will be displayed based on sorting and filters
        statusOptions: statusOptions,
        selectEnabled: selectEnabled,
        showSearchSuggestions: false,
        title: title
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!(0, _lodash.isEqual)(prevProps.rows, this.props.rows) // check if rows from props have changed
      // also check if the latest props rows are different than current state of rowData to prevent reloading from internal changes and the onChange being used to push the rows back into the table
      && !(0, _lodash.isEqual)(this.state.rowData, this.props.rows)) {
        var selectedRows = this.props.rows.filter(function (row) {
          return row.selected;
        });
        var rowData = this.getFormattedRowData(selectedRows);
        var pageIndex = this.state.tableSettings.pageIndex; // if source data changes, change pagination back to first page

        if (prevProps.rows.length !== this.props.rows.length) {
          pageIndex = 0;
        }

        this.setState({
          rowData: rowData,
          tableSettings: _objectSpread(_objectSpread({}, this.state.tableSettings), {}, {
            selectedRows: selectedRows,
            pageIndex: pageIndex
          })
        });
      }

      if (!(0, _lodash.isEqual)(prevProps.columns, this.props.columns)) {
        // watches for any changes in columns, usually going to be with statusOptions or dropdownDisabled
        var formattedColumns = this.getFormattedColumns(this.props.columns);
        var statusOptions = this.getFormattedStatusOptions();
        this.setState({
          columns: formattedColumns,
          statusOptions: statusOptions
        });
      }

      if (prevProps.selectEnabled !== this.props.selectEnabled) {
        this.setState({
          selectEnabled: this.props.selectEnabled
        });
      }

      if (prevProps.emptyMessage !== this.props.emptyMessage) {
        // update empty message, if changed
        this.setState({
          emptyMessage: this.props.emptyMessage
        });
      }

      if (prevProps.actions !== this.props.actions) {
        // update actions, if changed
        this.setState({
          actions: this.props.actions
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          style = _this$props3.style,
          loading = _this$props3.loading;
      var childProps = {
        loading: loading,
        tableData: this.state,
        tableActions: {
          // TableHeader actions
          selectAllRowsHandle: this.selectAllRowsHandle,
          // also used in TableToolbar for bulkActions or bulkStatusChange
          // helper actions
          actionsByTypeGet: function actionsByTypeGet(actionType) {
            return _this2.props.actions.filter(function (action) {
              return action.type === actionType;
            });
          },
          getFormattedRowData: this.getFormattedRowData,
          getVisibleColumns: this.getVisibleColumns,
          onChange: this.props.onChange,
          updateTableState: function updateTableState(updatedStateValues) {
            _this2.setState(updatedStateValues, function () {
              return _this2.props.onChange(_this2.state.rowData, _this2.state.tableSettings);
            });
          }
        }
      };

      var clonedChildren = _react["default"].Children.toArray(children).map(function (child) {
        return /*#__PURE__*/_react["default"].cloneElement(child, childProps);
      });

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "SmartTable_container",
        style: _objectSpread({}, style)
      }, clonedChildren);
    }
  }]);

  return SmartTable;
}(_react.Component);

exports.SmartTable = SmartTable;

_defineProperty(SmartTable, "propTypes", {
  // should absolutely be provided

  /** The key of a unique ID on the table data */
  idKey: _propTypes["default"].string.isRequired,

  /** The columns to be displayed on the table */
  columns: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    /**
     * Callback to apply custom formatting to a column. Does not affect filtering or sorting.
     * Callback is passed the data value for the column key and row data for each row.
     * Must return a value or element for the table to use.
     * 
     * @example
     * row[columnKey] = 10;
     * ...
     * format: (value, rowData) => `value%` // row will show as "10%"
     */
    format: _propTypes["default"].func,

    /** the key on the data object for the column */
    key: _propTypes["default"].string.isRequired,

    /** the name to be displayed as the column header */
    title: _propTypes["default"].string.isRequired,

    /** number that can be provided to give different search priority, default is 1, higher is more priority */
    weight: _propTypes["default"].number,

    /** boolean that determines if the column is shown or not */
    show: _propTypes["default"].bool,

    /**
     * The devices (screen widths) to hide a column on.
     * Screen widths:
     *   phone: < 600px
     *   tablet: >= 600px && < 1200px
     *   desktop: >= 1200px
     * 
     * @example
     * hideOn: ['phone'] // will display on tablet and desktop
     * hideOn: ['phone', 'tablet'] // will only display on desktop
     * Missing hideOn prop // will show on phone, tablet, and desktop
     */
    hideOn: _propTypes["default"].arrayOf(_propTypes["default"].oneOf([types.PHONE, types.TABLET])),

    /** the inline styles to be applied to the column */
    customStyle: _propTypes["default"].object,

    /** options provided for a dropdown selection */
    statusOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      display: _propTypes["default"].string,
      // value will be used as display, if not provided
      value: _propTypes["default"].string.isRequired,
      disabled: _propTypes["default"].bool,
      onClick: _propTypes["default"].func // custom onClick for a status value, callback that provides all rowData and the value clicked

    })),

    /** the data type of the column */
    type: _propTypes["default"].oneOf([types.STRING, types.NUMBER, types.DATE, types.DATE_STRING, types.DATE_TIME, types.CURRENCY, types.BOOLEAN]).isRequired,

    /** boolean that can be provided to set column as filterable. defaults true. false will exclude it from filter list */
    canFilter: _propTypes["default"].bool,

    /** boolean that can be provided to set column as filterable. defaults true. false will exclude it from searches */
    canSearch: _propTypes["default"].bool,

    /** boolean provided to disable dropdown. only used if also using statusOptions */
    dropdownDisable: _propTypes["default"].bool
  })).isRequired,

  /** The data to be used by the table */
  rows: _propTypes["default"].array.isRequired,
  /// optional props ///
  loading: _propTypes["default"].bool.isRequired,

  /** Callback to receive rowData back on any change as 1st argument and tableSettings as optional 2nd argument */
  onChange: _propTypes["default"].func,
  actions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    /** The display name for ROW_BUTTON, ROW_ICON, ROW_MENU, and BULK_ACTION actions */
    displayName: _propTypes["default"].string,

    /** The type of the action */
    type: _propTypes["default"].oneOf([types.ROW_MENU, types.ROW_ICON, types.ROW_BUTTON, types.BULK_ACTION]).isRequired,

    /**
     * Callback to be fired when action is clicked
     * For ROW_ICON & ROW_MENU, callback will be passed the row data for the row that was clicked
     * For ROW_BUTTON, callback will be passed the row data for the row that was clicked
     * For BULK_ACTION, callback will be passed an array of the row data for the selected rows
     */
    onSelect: _propTypes["default"].func.isRequired,

    /**
     * Callback to determine if action should be displayed for a row. Used only for ROW_BUTTON, ROW_ICON, and ROW_MENU actions.
     * Callback must return truthy or falsy value.
     */
    showIf: _propTypes["default"].func,
    /// props for icons ///

    /** Material Icon key for icon */
    icon: (0, _reactRequiredIf["default"])(_propTypes["default"].string, function (props) {
      return props.type === types.ROW_ICON || props.type === types.BULK_ACTION;
    }),

    /** Title for icon that shows on hover, won't show if not provided */
    iconTitle: _propTypes["default"].string,
    /// props for button ///

    /** 
     * Variant for button, default is contained.
     * Button color will default as default, if different variant is provided, it will change to primary
     */
    variant: _propTypes["default"].string,

    /** Label for button */
    label: (0, _reactRequiredIf["default"])(_propTypes["default"].string, function (props) {
      return props.type === types.ROW_BUTTON;
    }),

    /**
     * Callback that provides the row and determines if the row button should be loading. Used only for ROW_BUTTON.
     * Callback must return truthy or falsy value.
     */
    loading: _propTypes["default"].func,

    /**
     * Callback that provides the row and determines if the row button should be disabled. Used only for ROW_BUTTON or ROW_ICON.
     * Callback must return truthy or falsy value.
     */
    disabled: _propTypes["default"].func
  })),

  /** Boolean to turn on checkbox selection for rows, default is false */
  selectEnabled: _propTypes["default"].bool.isRequired,
  style: _propTypes["default"].object,

  /** String to display as Title over table, goes in TableToolbar section */
  title: _propTypes["default"].string,

  /** String to display in TableRows area when no data is provided */
  emptyMessage: _propTypes["default"].string,

  /** Settings that can be provided to set the initial mounting of the table */
  tableSettings: _propTypes["default"].shape({
    pageIndex: _propTypes["default"].number,
    rowsPerPage: _propTypes["default"].number,
    searchTerm: _propTypes["default"].string,
    selectedRows: _propTypes["default"].array,
    selectedFilters: _propTypes["default"].object,
    sortColumn: (0, _reactRequiredIf["default"])(_propTypes["default"].string, function (props) {
      return props.sortDirection !== undefined;
    }),
    // required is sortDirection is provided
    sortDirection: _propTypes["default"].string
  }).isRequired,

  /** Size of component and window (injected by Sizify) */
  size: _propTypes["default"].object.isRequired
});

SmartTable.defaultProps = {
  loading: false,
  actions: [],
  emptyMessage: 'No data to display.',
  initialPageIndex: 0,
  onChange: function onChange() {
    return null;
  },
  selectEnabled: false,
  statusOptions: [],
  tableSettings: defaultTableSettings,
  title: ''
};

var _default = (0, _Sizify["default"])(SmartTable);

exports["default"] = _default;